module.exports = __webpack_public_path__ + "img/cnhlite.53e3ddfc.png";